import { useProjectSessionInit } from "lib/project-sessions/useProjectSessionInit";
import { PublishedPageRenderer } from "./PublishedPageRenderer";
import BuilderPageSpinner from "components/BuilderPageSpinner";
import { ProjectAuthPage } from "components/ProjectAuth/ProjectAuthPage";
import { CurrentProjectProvider } from "lib/context/current-project-context";
import { EmbedProvider } from "lib/context/embed-context";
import { userHasAccess } from "lib/utils/stripe";
import { ProjectAuthType } from "@prisma/client";
import { ProjectError } from "./ProjectError";

export function PublishedPage(props: {
  isEmbed: boolean;
  noBackground?: boolean;
}) {
  const { data, refetch, isLoading, isRefetching } = useProjectSessionInit();

  if (isLoading || isRefetching || !data) {
    return <BuilderPageSpinner />;
  }

  if (
    data.project.authType !== ProjectAuthType.None &&
    !(
      userHasAccess(
        data.project.creator.planId,
        data.project.creator.isStaff,
        "managedUsers"
      ) ||
      userHasAccess(
        data.project.creator.planId,
        data.project.creator.isStaff,
        "passwordProtect"
      )
    )
  ) {
    return (
      <ProjectError
        title="Project cannot be rendered"
        message="Project access settings are enabled for your account, but your account is not upgraded; please consider upgrading your account or clear access settings to view the project."
      />
    );
  }

  if (data.authorized === false) {
    if (data.project.authType === "None") {
      throw new Error(
        'sessionInit is not authorized, but Project authType is "None"'
      );
    }

    return (
      <ProjectAuthPage
        projectId={data.project.id}
        captchaEnabled={data.project.captchaEnabled}
        projectAppearance={data.project.appearance}
        projectLogo={data.project.logo}
        authType={data.project.authType}
        onAuthSuccess={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <CurrentProjectProvider project={data.project}>
      <EmbedProvider embed={props}>
        <PublishedPageRenderer
          pageId={data.pageId}
          pageTitle={data.pageTitle}
          isEmbed={props.isEmbed}
        />
      </EmbedProvider>
    </CurrentProjectProvider>
  );
}
